import styled from 'styled-components';

export const LoadingWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100vw;
`;

export const Logo = styled.img`
    width: 20vw;
    height: auto;
    // aspect-ratio: 1/1;
    padding: 1rem;
`;